import { useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { submitProtest } from '../services/api';
import '../styles/fonts.css';
import '../styles/organizer.css';

function ProtestForm() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const protestToken = searchParams.get('protest_token') || '';
  const custId = searchParams.get('cust_id') || '';
  const displayName = searchParams.get('display_name') || '';
  const protestError = searchParams.get('protest_error') || '';

  const [description, setDescription] = useState('');
  const [attachment, setAttachment] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const errorMessage = protestError === 'nao_participou'
    ? t('protest.notParticipated')
    : protestError
    ? t('protest.authError')
    : null;

  async function handleSubmit(e) {
    e.preventDefault();
    if (!description.trim()) return;
    setSubmitting(true);
    setError(null);
    try {
      await submitProtest(id, protestToken, description, attachment);
      setSuccess(true);
    } catch (err) {
      const msg = err?.error || err?.detail || '';
      if (msg.toLowerCase().includes('token')) {
        setError(t('protest.tokenExpired'));
      } else {
        setError(t('protest.submitError'));
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="OrganizerPage">
      <Header />
      <main>
        <div className="organizer-content">
          <div className="organizer-panel-header" style={{ marginBottom: 24 }}>
            <div>
              <p className="organizer-panel-label">
                <Link to={`/races/${id}`} className="organizer-back-link">
                  ← {t('protest.pageTitle')}
                </Link>
              </p>
              <h1 className="organizer-panel-name">{t('protest.pageTitle')}</h1>
            </div>
          </div>

          {errorMessage && (
            <div className="organizer-form-card">
              <p className="organizer-error" style={{ margin: 0 }}>{errorMessage}</p>
              <Link to={`/races/${id}`} className="btn-secondary" style={{ marginTop: 16, display: 'inline-block' }}>
                ← Voltar
              </Link>
            </div>
          )}

          {!errorMessage && !protestToken && (
            <div className="organizer-form-card">
              <p className="organizer-error" style={{ margin: 0 }}>{t('protest.tokenExpired')}</p>
              <Link to={`/races/${id}`} className="btn-secondary" style={{ marginTop: 16, display: 'inline-block' }}>
                ← Voltar
              </Link>
            </div>
          )}

          {!errorMessage && protestToken && !success && (
            <div className="organizer-form-card">
              <form className="organizer-form" onSubmit={handleSubmit}>
                <div className="form-section">
                  <label className="form-label">
                    {t('protest.pilotLabel')}
                    <input
                      type="text"
                      className="form-input"
                      value={`${displayName} (ID: ${custId})`}
                      readOnly
                      style={{ opacity: 0.75, cursor: 'default' }}
                    />
                  </label>

                  <label className="form-label" style={{ marginTop: 16 }}>
                    {t('protest.descriptionLabel')}
                    <textarea
                      className="form-input"
                      style={{ width: '100%', minHeight: 160, resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.6, marginTop: 6 }}
                      value={description}
                      onChange={e => setDescription(e.target.value)}
                      placeholder={t('protest.descriptionPlaceholder')}
                      required
                    />
                  </label>

                  <label className="form-label" style={{ marginTop: 16 }}>
                    {t('protest.attachmentLabel')}
                    <p className="organizer-subtitle" style={{ marginBottom: 6 }}>{t('protest.attachmentHint')}</p>
                    <input
                      type="file"
                      accept="video/*,image/*"
                      className="form-input"
                      style={{ padding: '8px 12px' }}
                      onChange={e => setAttachment(e.target.files[0] || null)}
                    />
                  </label>
                </div>

                {error && <p className="form-error" style={{ marginTop: 12 }}>{error}</p>}

                <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
                  <button type="submit" className="btn-primary" disabled={submitting || !description.trim()}>
                    {submitting ? t('common.saving') : t('protest.submitBtn')}
                  </button>
                  <Link to={`/races/${id}`} className="btn-secondary">
                    {t('organizer.cancel')}
                  </Link>
                </div>
              </form>
            </div>
          )}

          {success && (
            <div className="organizer-form-card">
              <p className="form-success" style={{ margin: 0 }}>{t('protest.submitSuccess')}</p>
              <Link to={`/races/${id}`} className="btn-secondary" style={{ marginTop: 16, display: 'inline-block' }}>
                ← Voltar para a corrida
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ProtestForm;
